import { jsx } from "react/jsx-runtime";
import { cn } from "../../../utils/cn.js";
import { forwardRef } from "react";
const PageContent = forwardRef(({ children, className }, ref) => {
  return /* @__PURE__ */ jsx(
    "main",
    {
      className: cn("flex flex-grow flex-col", className),
      ref,
      children
    }
  );
});
const PageContent$1 = PageContent;
export {
  PageContent$1 as default
};
